import { STORE_ACTIONS } from '~~/_core/constants/enums';

export const types = {};

export const state = () => ({});

export const getters = {};

export const actions = {
  async nuxtServerInit({ commit }, context) {
    // const $logger = context.$logger;

    try {
      // $logger.console('Initial Request', 'Getting Initial Token');
    } catch (e) {
      const url = context.route.fullPath;

      // $logger.error('Nuxt Server Init', e.message, {
      //   url,
      // });

      return context.error({
        statusCode: 404,
        message: e.message,
      });
    }

    return true;
  },
};

export const mutations = {};
